import { ScheduleActionsContainerProvider } from '../../context/ScheduleActionsContainerContext';
import { CalendarProvider } from '../../stores/calendar.store';
import { ScheduleActionsModalContainer } from '../Calendar/EventsPanel/ScheduleActions/ScheduleActionsModalContainer';

interface Props {
  isSmallModeWindow?: boolean;
  onClose?: () => void;
}

const Component = ({ onClose, isSmallModeWindow = false }: Props) => {
  return (
    <ScheduleActionsContainerProvider closeModal={onClose} isSmallModeWindow={isSmallModeWindow}>
      <ScheduleActionsModalContainer />
    </ScheduleActionsContainerProvider>
  );
};

export const SchedulePulseTrayContent = (props: Props) => {
  // for small mode case, we were already in the context provider (of calendar page)
  // so we can directly use the component without wrapping it again
  if (props.isSmallModeWindow) {
    return <Component {...props} />;
  }

  return (
    <CalendarProvider isForSchedulePulse>
      <Component {...props} />
    </CalendarProvider>
  );
};
